import React from 'react';
import { Card, CardContent } from './ui/card';

export const StatsCard = ({ title, value, subtitle, icon, trend }) => {
  return (
    <Card className="card-hover overflow-hidden">
      <CardContent className="p-3">
        <div className="flex items-center justify-between gap-2">
          <div className="flex-1 min-w-0">
            <p className="text-xs font-medium text-muted-foreground truncate">{title}</p>
            <h3 className="text-2xl font-bold font-display mt-0.5 text-foreground">{value}</h3>
            {subtitle && (
              <p className="text-xs text-muted-foreground mt-0.5 truncate">{subtitle}</p>
            )}
          </div>
          {icon && (
            <div className="w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
              <div className="w-5 h-5">
                {icon}
              </div>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
